import { render, staticRenderFns } from "./PastDraws.vue?vue&type=template&id=f65f0f8c&scoped=true&"
import script from "./PastDraws.vue?vue&type=script&lang=js&"
export * from "./PastDraws.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/past-draws.scss?vue&type=style&index=0&id=f65f0f8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f0f8c",
  null
  
)

export default component.exports